export const wishlisted = (wishlistItems, item) => wishlistItems.some(el => el.id === item.id)
